import { fetchJobs } from "actions/jobs";
import RequireData from "hooks/RequireData";
import React from "react";
import fetchJobsStatusSelector from "selectors/fetchJobsStatus";
import jobsSelector from "selectors/jobs";
import JobsListItem from "./JobsListItem";
import JobsListLoading from "./JobsListLoading";

const JobsList: React.FC = () => {
    const [data, status] = RequireData(
        jobsSelector,
        fetchJobsStatusSelector,
        fetchJobs()
    );

    if (status === "loading" || !data) {
        return <JobsListLoading />;
    }

    return (
        <div className="list-group">
            {data.map((j) => (
                <JobsListItem key={j.id} job={j} />
            ))}
        </div>
    );
};

export default JobsList;
